import { render } from "./HomeGate.vue?vue&type=template&id=5a56f2ed"
import script from "./HomeGate.vue?vue&type=script&lang=js"
export * from "./HomeGate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__